(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aotd-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const key = 'aotd-newsletter-v1';
    const pendingKey = key + '-pending';
    const controllers = new WeakMap();
    const read = (storage, name) => { try { return window[storage].getItem(name); } catch { return null; } };
    const write = (storage, name, value) => { try { window[storage].setItem(name, value); } catch {} };
    const remove = (storage, name) => { try { window[storage].removeItem(name); } catch {} };
    const suppressed = () => {
      const value = read('localStorage', key) || read('sessionStorage', key);
      if (value === 'subscribed') return true;
      return Number(value) > Date.now();
    };
    const remember = value => {
      write('localStorage', key, String(value));
      write('sessionStorage', key, String(value));
    };
    const init = root => {
      for (const host of root.querySelectorAll('[data-aotd-newsletter]')) {
        if (controllers.has(host)) continue;
        const dialog = host.querySelector('dialog');
        if (!dialog || typeof dialog.showModal !== 'function') continue;
        const abort = new AbortController();
        const signal = abort.signal;
        let timer;
        controllers.set(host, () => { clearTimeout(timer); abort.abort(); if (dialog.open) dialog.close(); });
        const editor = host.dataset.editor === 'true';
        const form = host.querySelector('form');
        const pending = Number(read('sessionStorage', pendingKey));
        const recentSubmission = pending > Date.now() - 30 * 60 * 1000;
        const returnedToForm = location.hash === '#' + form.id || recentSubmission;
        const success = host.querySelector('[data-popup-success]');
        const errors = host.querySelector('[data-popup-errors]');
        const open = () => { if (!dialog.open) dialog.showModal(); };
        const dismiss = () => {
          if (!editor && !success) remember(Date.now() + Number(host.dataset.days) * 86400000);
          dialog.close();
        };
        for (const button of host.querySelectorAll('[data-popup-close]')) button.addEventListener('click', dismiss, { signal });
        dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); }, { signal });
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const controls = [...dialog.querySelectorAll('button:not([disabled]),input:not([type="hidden"]):not([disabled]),a[href]')].filter(element => element.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }, { signal });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss();
        }, { signal });
        form.addEventListener('submit', () => { if (!editor) write('sessionStorage', pendingKey, String(Date.now())); }, { signal });
        if (success) {
          if (!editor) remember('subscribed');
          if (returnedToForm) open();
          remove('sessionStorage', pendingKey);
          return;
        }
        if (errors && returnedToForm) { open(); return; }
        if (editor) {
          const section = host.closest('.shopify-section');
          section?.addEventListener('shopify:section:select', open, { signal });
          section?.addEventListener('shopify:section:deselect', () => dialog.close(), { signal });
          return;
        }
        if (suppressed()) return;
        const showWhenReady = () => {
          if (!host.isConnected || suppressed()) return;
          const busy = document.hidden || document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
          if (busy) { timer = setTimeout(showWhenReady, 1000); return; }
          open();
        };
        timer = setTimeout(showWhenReady, Number(host.dataset.delay) * 1000);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:section:unload', event => {
      for (const host of event.target.querySelectorAll('[data-aotd-newsletter]')) { controllers.get(host)?.(); controllers.delete(host); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
